<template>
  <div>
    <div v-if="devMode" id="debugpanel" class="rounded-lg">
      <div class="mb-2 d-block">Kártyaolvasó szimulátor</div>
      <v-btn small depressed @click="simulateRead('7E3966CE')" class="my-1 d-block" color="orange" block>Kártya:
        Áron</v-btn>
      <v-btn small depressed @click="simulateRead('99E5637A')" class="my-1 d-block" color="orange" block>002. Kültéri F.
        előtér</v-btn>
      <v-btn small depressed @click="simulateRead('89C4FA7A')" class="my-1 d-block" color="orange" block>002. Kültéri F.
        előtér</v-btn>
      <v-btn small depressed @click="simulateRead('5800709E')" class="my-1 d-block" color="orange" block>005. Külső
        Menekülő lépcső</v-btn>
      <v-btn small depressed @click="simulateRead('99A60B7A')" class="my-1 d-block" color="orange" block>006. Közlekedő
        bal</v-btn>
      <v-btn small depressed @click="simulateRead('11122233')" class="my-1 d-block" color="orange" block>Nem létező
        rfid</v-btn>
    </div>

    <v-card-text>
      <div class="text-h4 text-center text-uppercase font-weight-bold">Eszközök kiadása</div>

      <v-row>
        <v-col cols="12" md="6">
          <v-card flat class="rounded-xl text-center my-6" style="overflow: hidden;">
            <v-overlay :value="loading" absolute>
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card-title class="text-subtitle-1 font-weight-bold">
              Igénylő
            </v-card-title>
            <v-card-text>
              <div v-if="card" class="d-flex align-center">
                <div class="mr-4">
                  <v-avatar width="50" height="64" color="grey ligthen-2" rounded>
                    <v-img v-if="card.photo" :src="`data:image/png;base64,${card.photo}`" @click="lightbox = true" />
                    <v-icon v-else size="40">mdi-account</v-icon>
                  </v-avatar>
                </div>
                <div class="text-left">
                  <div class="text-body-1 font-weight-bold">{{ card.owner_name }}</div>
                  <div>Kártyaszám: {{ card.card_number }}</div>
                </div>
              </div>
              <div v-else class="d-flex flex-column justify-center">
                <div class="icon-container">
                  <v-icon size="96" class="my-6">mdi-scan-helper</v-icon>
                  <v-icon size="48" class="center">mdi-card-account-details</v-icon>
                  <div class="spinner center"></div>
                </div>
                Érintse a kártyát az olvasóhoz!
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card flat class="rounded-xl text-center my-6" style="overflow: hidden;">
            <v-overlay :value="loading" absolute>
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card-title class="text-subtitle-1 font-weight-bold">
              Eszközök
            </v-card-title>
            <v-card-text>
              <v-card v-for="asset in assets" :key="`asset-${asset.element_id}`" flat color="background"
                class="rounded-xl my-1">
                <v-card-text class="d-flex align-center pa-2" style="position: relative; overflow: hidden;">
                  <div style="position: absolute; left: 0; top: 0; bottom: 0;" class="h-full">
                    <div v-if="asset.permitted === undefined" style="width: 60px; height: 100%;"
                      class="text-center d-flex align-center justify-center">
                      <VProgressCircular indeterminate size="40" color="white"></VProgressCircular>
                    </div>
                    <div v-else-if="asset.permitted" style="width: 60px; height: 100%;"
                      class="text-center d-flex align-center justify-center green">
                      <v-icon size="40" color="white">mdi-check</v-icon>
                    </div>
                    <div v-else style="width: 60px; height: 100%;"
                      class="text-center d-flex align-center justify-center error">
                      <v-icon size="40" color="white">mdi-cancel</v-icon>
                    </div>
                  </div>

                  <div class="ml-16">
                    <v-sheet :color="`${asset.color || 'grey'}`" width="8" height="40" rounded="sm" class="mr-2" />
                  </div>

                  <div class="text-left">
                    <div class="text-body-1 font-weight-bold">{{ asset.name }}</div>
                  </div>

                  <div class="ml-auto">
                    <v-btn icon color="red" @click="assets = assets.filter(a => a.element_id !== asset.element_id)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
              <div v-if="assets.length === 0" class="d-flex flex-column justify-center">
                <div class="icon-container">
                  <v-icon size="96" class="my-6">mdi-scan-helper</v-icon>
                  <v-icon size="48" class="center">mdi-key</v-icon>
                  <div class="spinner center"></div>
                </div>
                Érintse az eszközöket az olvasóhoz!
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-card flat class="rounded-xl">
        <v-card-title class="text-subtitle-1 font-weight-bold">
          Megjegyzés
        </v-card-title>
        <v-card-text>
          <v-textarea v-model="remark" rows="3" auto-grow filled autofocus hide-details placeholder="Megjegyzés" />
        </v-card-text>
      </v-card>

      <v-card v-if="assets.length > 0 && card" flat class="rounded-xl mt-6 text-center">
        <v-card-text>
          <div class="text-h6">Megtörtént az {{ assets.length === 1 ? 'eszköz' : 'eszközök' }} kiadása?</div>

          <v-btn color="error" class="ma-4 rounded-xl" width="200" depressed x-large @click="$emit('close')">
            <v-icon left>mdi-close-thick</v-icon>
            NEM
            <kbd flat class="ml-2">Esc</kbd>
          </v-btn>
          <v-btn color="success" class="ma-4 rounded-xl" width="200" depressed x-large @click="taken">
            <v-icon left>mdi-check-bold</v-icon>
            IGEN
            <kbd flat class="ml-2">Enter</kbd>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-card-text>
  </div>
</template>

<script>
import { VProgressCircular } from 'vuetify/lib';

export default {
  data() {
    return {
      loading: false,
      rfid: '',
      card: null,
      assets: [],
      remark: '',
      readerDisabled: false,
      socket: false,
      socketError: false,
    };
  },

  mounted() {
    this.watchCardReader();
    document.addEventListener('keyup', this.keyupHandler, true);
  },

  beforeDestroy() {
    this.socket.close();
    document.removeEventListener('keyup', this.keyupHandler, true);
  },

  methods: {
    keyupHandler(e) {
      switch (e.key) {
        case 'Escape':
          this.reset();
          break;
        case 'Enter':
          this.taken();
          break;
        default:
          break;
      }
    },

    reset() {
      this.readerDisabled = false;
      this.card = null;
      this.assets = [];
      this.remark = '';
    },

    async checkAccess(card, assets) {
      const response = await this.$http.post('assets/check-access', {
        card: card,
        assets: assets,
      });
      return response;

    },

    async taken() {
      try {
        const res = await this.$http.post('assets/take', {
          card: this.card,
          assets: this.assets,
          remark: this.remark,
        });
        if (res.status !== 'OK') {
          throw Error('Sikertelen eszköz kiadás!');
        }
        this.$dialog.notify.success('Sikeres eszköz kiadás!');
      } catch (err) {
        this.$dialog.notify.error(err.response.data.message || 'Váratlan hiba történt!');
        return;
      }

      this.reset();
    },

    async watchCardReader() {
      if (this.socket.readyState === WebSocket.OPEN) {
        this.socket.close();
      }

      try {
        this.socket = new WebSocket('wss://kmr-reader.uninet.hu:8080');

        this.socket.onmessage = async (event) => {
          if (!event.data || this.readerDisabled) {
            return;
          }
          this.handleRead(event.data);
        };
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
      this.reset();
    },

    async handleRead(rfid) {
      try {
        this.loading = true;
        this.readerDisabled = true;
        setTimeout(() => {
          if (this.card && this.asset) {
            return;
          }
          this.readerDisabled = false;
        }, 500);
        const response = await this.$http.get(`assets/lookup/${rfid}`);
        if (!response.asset && !response.card) {
          throw Error('Ez a kártya vagy eszköz nincs a rendszerben!');
        }

        if (response.asset && this.assets.length === 10) {
          this.$dialog.notify.error('Egyszerre maximum 10 eszközt lehet felvenni!', {
            position: 'bottom-right',
          });
          return;
        }

        this.card = response.card ?? this.card;
        if (response.asset && !this.assets.find(a => a.element_id === response.asset.element_id)) {
          this.assets.push(response.asset);
        }

        if (this.card && this.assets.length > 0) {
          const response = await this.checkAccess(this.card, this.assets);
          this.assets = response.assets;
        }
      } catch (err) {
        this.$dialog.notify.error(err.message, {
          position: 'bottom-right',
        });
      } finally {
        this.loading = false;
      }
    },

    // debug methods
    async simulateRead(rfid) {
      this.handleRead(rfid);
    },
  },

  computed: {
    devMode() {
      return process.env.NODE_ENV === 'development';
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-container {
  position: relative;

  .center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.spinner {
  width: 120%;
  aspect-ratio: 1/1;
  background-color: #8882;

  border-radius: 100%;
  -webkit-animation: sk-scaleout 4s infinite ease-in-out;
  animation: sk-scaleout 4s infinite ease-in-out;
  z-index: 0;
}

@-webkit-keyframes sk-scaleout {
  0% {
    -webkit-transform: translate(-50%, -50%) scale(0);
  }

  50% {
    -webkit-transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }

  100% {
    -webkit-transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% {
    -webkit-transform: translate(-50%, -50%) scale(0);
    transform: translate(-50%, -50%) scale(0);
  }

  50% {
    -webkit-transform: translate(-50%, -50%) scale(1);
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }

  100% {
    -webkit-transform: translate(-50%, -50%) scale(1);
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
}

#debugpanel {
  position: fixed;
  bottom: 5px;
  right: 5px;
  padding: 0.75rem;
  border: 2px solid #ffa014;
  background-color: #0004;
  backdrop-filter: blur(10px);
  color: #fffa;
  z-index: 100;
}
</style>
